export default {
    root: {
        class: [
            'tw-w-full',
            'tw-h-full',
            // Flexbox
            'tw-flex',
            'tw-items-stretch',
            'tw-gap-x-1',
            // Shape
            'tw-rounded-md',
        ],
    },
    rootList: {
        class: [
            // Flexbox
            'lg:tw-h-full',
            'lg:tw-flex',
            'tw-items-stretch',
            'tw-justify-center',
            'tw-flex-row tw-gap-x-1',
            // Position
            'lg:tw-relative',
            'tw-right-0 lg:tw-left-0',
            'lg:tw-top-auto lg:tw-left-auto',
            // Spacing
            'tw-m-0',
            // Shape
            'lg:tw-shadow-none',
            // Misc
            'tw-outline-none',
            'tw-list-none',
        ],
    },
    item: {
        class: 'lg:tw-relative lg:tw-w-auto tw-w-full tw-static',
    },
    itemcontent: {
        class: 'tw-h-full',
    },
    itemLink: function (_a) {
        var props = _a.props, context = _a.context;
        return ({
            class: [
                'tw-relative',
                // Disabled State
                { 'tw-opacity-60 tw-pointer-events-none': context.disabled },
                // Flexbox
                'tw-flex',
                'tw-items-center',
                'tw-w-full',
                // Spacing
                'tw-px-2',
                // Size
                {
                    'tw-min-h-11 lg:tw-h-full': context.level === 0,
                    'tw-min-h-9 tw-border-0': context.level === 1,
                },
                // Text
                'tw-text-base',
                'tw-leading-none',
                // Color
                {
                    'lg:hover:tw-bg-transparent lg:hover:tw-text-zinc-950 tw-text-zinc-800 lg:tw-border-transparent lg:tw-border-b-2 lg:hover:tw-border-primary-500': context.level === 0,
                    'hover:tw-bg-primary-500 hover:tw-text-white': context.level === 1,
                },
                //Focus
                'focus:tw-outline-none focus:tw-ring-0 focus:tw-ring-offset-0 focus-visible:tw-outline-2 focus-visible:tw-ring-2 focus-visible:tw-ring-offset-2 focus-visible:tw-ring-primary-700',
                // Misc
                'tw-select-none',
                'tw-cursor-pointer',
                'tw-no-underline ',
                'tw-overflow-hidden',
                'tw-transition-colors tw-duration-200',
            ],
        });
    },
    submenu: function (_a) {
        var context = _a.context;
        return ({
            class: [
                // Flexbox
                'tw-flex tw-flex-col',
                // Color
                'tw-bg-white',
                // Size
                'lg:tw-min-w-64',
                // Spacing
                'tw-m-0',
                // Shape
                'tw-rounded',
                // Position
                'lg:tw-absolute',
                { 'lg:tw-absolute lg:tw-left-full lg:tw-top-0': (context === null || context === void 0 ? void 0 : context.level) > 1 },
                // Misc
                'tw-z-10',
                'tw-shadow-none lg:tw-shadow-md',
                'tw-list-none',
            ],
        });
    },
    separator: {
        class: 'tw-border-t tw-border-zinc-200 tw-dark:border-zinc-600',
    },
    button: {
        class: 'tw-hidden',
    },
    end: {
        class: 'tw-ml-auto lg:tw-flex-1',
    },
    start: {
        class: 'tw-h-full tw-flex tw-items-center lg:tw-flex-1',
    },
};
